import { Role } from '@/shared-types/roleTypes';

export const EDIT_CONFIGURATION_PERMISSIONS: {
  [field: string]: { production: Role[]; cte: Role[] };
} = {
  identifier: {
    production: [],
    cte: ['admin', 'creator'],
  },
  marketData: {
    production: [],
    cte: ['admin', 'creator', 'editor'],
  },
  searchable: {
    production: [],
    cte: ['admin', 'creator'],
  },
  includeDeeplinkParams: {
    production: [],
    cte: ['admin'],
  },
  includeListingSearchParams: {
    production: [],
    cte: ['admin'],
  },
  contentPageVariant: {
    production: [],
    cte: ['admin', 'creator'],
  },
  category: {
    production: [],
    cte: ['admin', 'creator'],
  },
  imageUrl: {
    production: [],
    cte: ['admin', 'creator'],
  },
  secondaryBannerImgUrl: {
    production: [],
    cte: ['admin', 'creator'],
  },
  plannerUrl: {
    production: [],
    cte: ['admin', 'creator'],
  },
  supportedDevices: {
    production: [],
    cte: ['admin', 'creator'],
  },
  showInPages: {
    production: [],
    cte: ['admin', 'creator'],
  },
  productsInclude: {
    production: [],
    cte: ['admin', 'creator'],
  },
  productsExclude: {
    production: [],
    cte: ['admin', 'creator'],
  },
  rangeInclude: {
    production: [],
    cte: ['admin', 'creator'],
  },
  rangeExclude: {
    production: [],
    cte: ['admin', 'creator'],
  },
  plannerContact: {
    production: [],
    cte: ['admin', 'creator'],
  },
};

export const EDIT_PHRASE_PERMISSIONS: {
  production: Role[];
  cte: Role[];
} = {
  production: [],
  cte: ['admin', 'creator'],
};

export const EDIT_PRODUCTION_PERMISSIONS: {
  [field: string]: { production: Role[]; cte: Role[] };
} = {
  restore: { production: ['admin'], cte: ['admin'] },
  publish: {
    production: ['admin'],
    cte: ['admin', 'creator'],
  },
};

export const ADD_CTA_PERMISSIONS: {
  production: Role[];
  cte: Role[];
} = {
  production: [],
  cte: ['admin', 'creator'],
};

export const PUBLISH_PERMISSIONS: {
  production: Role[];
  cte: Role[];
} = {
  production: ['admin'],
  cte: ['admin', 'creator', 'editor'],
};

export const SEND_PRODUCTION_APPROVAL_PERMISSIONS: {
  production: Role[];
  cte: Role[];
} = {
  production: [],
  cte: ['admin', 'creator', 'editor'],
};

export const RESTORE_PERMISSIONS: {
  production: Role[];
  cte: Role[];
} = {
  production: ['admin'],
  cte: ['admin', 'creator'],
};

export const SAVE_CHANGES_PERMISSIONS: {
  production: Role[];
  cte: Role[];
} = {
  production: [],
  cte: ['admin', 'creator', 'editor'],
};

export const MARKET_ENABLE_TOGGLE_PERMISSIONS: {
  production: Role[];
  cte: Role[];
} = {
  production: [],
  cte: ['admin', 'creator', 'editor'],
};
